import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable, Subject, UnaryFunction, finalize, pipe, takeUntil } from 'rxjs';

@Component({
    selector: 'base-component',
    imports: [CommonModule],
    template: ``
})
export class BaseComponentComponent implements OnInit {

  //#region properties
  protected onDestroy$ = new Subject<void>();
  loading: boolean = false;

  basePipeOperators = <T>() => pipe(
    finalize(() => {
      this.loading = false;
    }),
    takeUntil(this.onDestroy$),
  ) as UnaryFunction<Observable<T>, Observable<T>>;


  //#endregion


  constructor() { }

  ngOnInit(): void { window.scroll(0, 0); }

  unSubs() {
    this.onDestroy$.next();
  }

  ngOnDestroy() {
    this.unSubs();
    this.onDestroy$.complete();
  }

}
